import MNavigation from './index.vue';

MNavigation.install = app => {
  app.component(MNavigation.name, MNavigation);
};

export default MNavigation;
